import React, {useCallback, useEffect, useState} from "react";
import {ClientListRepository} from "../../repository/AdminDashboard/Client-Repository";
import toast from "react-hot-toast";
import {useSearchParams} from "react-router-dom";
import useListContext from "../../tools/useListContext";
import {useModal} from "../../tools/useModal";

const clientContext = React.createContext();
export const ClientContextProvider = ({children}) => {


    const {
        handleUpdateListState,
        listState,
        onDevicePerPageChange,
        changePage,
        onSearchBtnClick
    } = useListContext(getClients)

    const {closeModal, openModal, modalState} = useModal();

    async function getClients() {

        handleUpdateListState("loading", true)
        const response = await ClientListRepository.getClientList(listState.searchQuery, listState.pageNumber)
        handleUpdateListState("loading", false)

        if (response.code !== 1) {
            toast.error(response.massage, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        handleUpdateListState("list", response.clients)
        handleUpdateListState("countAll", response.countAllPages)
    }


    async function onAcceptDeleteClientClick() {
        const response = await ClientListRepository.deleteClient(modalState.selectedItem.id);
        if (response.code !== 1) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        closeModal()
        await getClients();
    }

    async function addUpdateClient(data) {
        data.number = "+98" + data.number.trim().slice(1);
        const response = await ClientListRepository.editAddClient(data);
        if (response.code !== 1) {
            console.log("Add Client Error")
            return;
        }
        await getClients();
    }

    function openDeleteModal(item) {
        openModal("delete", item)
    }

    function openAddEditModal(item) {
        openModal(item == null ? "add" : "edit", item)

    }

    return (
        <clientContext.Provider value={{
            onSearchBtnClick,
            changePage,
            onDevicePerPageChange,
            onAcceptDeleteClientClick,
            addUpdateClient,
            listState,
            handleUpdateListState,
            closeModal,
            openDeleteModal,
            openAddEditModal,
            modalState
        }}>
            {children}
        </clientContext.Provider>
    )
}

export function useClientContext() {
    return React.useContext(clientContext);
}